export const messages = {
  en: {
    deleteAdminServ: {
      confirmOperation: 'Please confirm your operation!',
      confirmDeleteService: 'Confirm to delete this service',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete'
    }
  },
  zh: {
    deleteAdminServ: {
      confirmOperation: '请确认您的操作!',
      confirmDeleteService: '确定删除该服务',
      cancel: '点错了',
      confirmDelete: '确认删除'
    }
  }
}